var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 30.5624,
    width: 29.125,
    height: 20.6875,
    rx: 1.63186,
    transform: "rotate(-90 0.5 30.5624)",
    stroke: "#010F55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 20.0464H17.0547",
    stroke: "#010F55",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 22.8589H17.0547",
    stroke: "#010F55",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 25.6714H12.8359",
    stroke: "#010F55",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 15.8291C6.46875 13.48 8.4275 11.5757 10.8437 11.5757C13.26 11.5757 15.2187 13.48 15.2187 15.8291M13.3437 7.32219C13.3437 8.66455 12.2245 9.75274 10.8437 9.75274C9.46304 9.75274 8.34375 8.66455 8.34375 7.32219C8.34375 5.97983 9.46304 4.89163 10.8437 4.89163C12.2245 4.89163 13.3437 5.97983 13.3437 7.32219Z",
    stroke: "#010F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportIcon);
export default __webpack_public_path__ + "static/media/passport-icon.1898f107b98788adb3b4e7f712116667.svg";
export { ForwardRef as ReactComponent };